<ng-container *translateBlock="let t">
  <app-dialog-base [title]="title"
                   [iconLeft]="iconLeft"
                   [class.open]="isOpen"
                   [buttonAction]="buttonAction">
    @if (message) {
      <p class="text">
        {{ t(message) }}
      </p>
    }

    <div class="button-row">
      <app-button-icon [label]="t('common.actions.confirm')"
                       class="iconless red"
                       (click)="confirmAction()" />

      <app-button-icon [label]="t('common.actions.cancel')"
                       class="iconless"
                       (click)="buttonAction()" />
    </div>
  </app-dialog-base>
</ng-container>
